import React from "react";
import { CreditsProvider } from "./CreditsContext";
import { AutoSaveProvider } from "./AutoSaveContext";
// Import future providers here

interface ContextProvidersProps {
  children: React.ReactNode;
}

export const ContextProviders: React.FC<ContextProvidersProps> = ({
  children
}) => {
  return (
    <CreditsProvider>
      <AutoSaveProvider>
        {/* Add future providers here, nesting from most global to most specific */}
        {children}
      </AutoSaveProvider>
    </CreditsProvider>
  );
};
